import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { StripHtmlPipe } from "../../../core/pipes/remove-html.pipe";
import { RestService } from "../../../core/services/rest.service";
import { ZorroTableComponent } from "../../common/custom-table/zorro-table.component";
import { LoadingComponent } from "../../common/loading/loading.component";
import { StarRankerComponent } from "../../common/star-ranker/star-ranker.component";

@Component({
  selector: "app-object-view-modal",
  standalone: true,
  imports: [
    LoadingComponent,
    CommonModule,
    ZorroTableComponent,
    MatExpansionModule,
    StripHtmlPipe,
    StarRankerComponent,
  ],
  templateUrl: "./object-view-modal.component.html",
  styleUrl: "./object-view-modal.component.scss",
})
export class ObjectViewModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  isActive:boolean = false;

  tableOptions: any = {
    pageSize: 10,
  };

  @Input()
  configs: any = {};

  @Input()
  isLoading: boolean = false;

  constructor(private restService: RestService) {}

  ngOnInit() {
    this.configs.title = "Objects & locators";
  }
}
